export default __webpack_public_path__ + "static/media/know_more.e5a79888.png";